import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: currentColor;\n\tmargin-left: ", ";\n\tmargin-top: ", ";\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var Icon = css(_templateObject(), ui.space(1), ui.space(-1));